module.exports = __webpack_public_path__ + "static/real_matter-a65cebeb42fa7e15a2f44ae60d64aab5.jpg";